// extracted by mini-css-extract-plugin
module.exports = {"headerSearch":"Search_headerSearch__JSd11","includeFormerEmployees":"Search_includeFormerEmployees__n9Alg","checkbox":"Search_checkbox__6WTYd","checked":"Search_checked__OhOH+"};